document.addEventListener("DOMContentLoaded", () => {

  /* =====================================================
     MV 初期アニメーション
  ===================================================== */
  document.querySelector(".mv_textBox")?.classList.add("scrollin");
  document.querySelector(".mv")?.classList.add("scrollin");


  document.querySelectorAll('.type_item').forEach(item => {
    item.addEventListener('click', function () {
      // 1. クリックされた要素のクラス名から 'select' で始まるものを取得
      const targetClass = Array.from(this.classList).find(cls => cls.startsWith('select'));

      if (targetClass) {
        // 2. 以前の active クラスをすべて削除
        document.querySelectorAll('.active').forEach(el => {
          el.classList.remove('active');
        });

        // 3. 同じ selectX クラスを持つすべての要素に active を一斉付与
        document.querySelectorAll('.' + targetClass).forEach(el => {
          el.classList.add('active');
        });
      }
    });
  });
});